<!--
 * @Author:
 * @Description:
 * @Date: 2024-09-18 15:03:17
 * @LastEditors: Please set LastEditors
 * @FilePath: /rhcn-merchant-web/src/views/register/networkApplication/components/step-status.vue
-->

<template>
  <div class="step_status" v-if="!isDisabled" v-loading="loading">
    <div class="descript">
      <p class="title">{{ $t('message.register.submit_and_review') }}</p>
      <p class="content">{{ $t('message.register.pleaseCheckAndSubmit') }}</p>
    </div>
    <div class="show_required_fields">
      <div class="business_type_required_fields" v-if="businessTypeRequierList.length > 0">
        <p class="title">{{ $t('message.register.companyType') }}</p>
        <div class="required_fields">
          <div class="required_field" v-for="item in businessTypeRequierList" :key="item.name">
            <div class="required_field_content">
              <img src="@/assets/image/icon_warning.png" alt="" class="required_icon">
              <p class="name">{{ $t(item.name) }}</p>
            </div>
            <span class="edit_btn" @click="editBusinessType('businessType', 0)">
              <img class="edit_icon" src="@/assets/image/icon-edit.png" alt="">
              <p class="edit_text">{{ $t('message.common.edit') }}</p>
            </span>
          </div>
        </div>
      </div>
      <div class="business_details_required_fields" v-if="businessDetailsRequierList.length > 0">
        <p class="title">{{ $t('message.register.companyDetails') }}</p>
        <div class="required_fields">
          <div class="required_field" v-for="item in businessDetailsRequierList" :key="item.key">
            <div class="required_field_content">
              <img src="@/assets/image/icon_warning.png" alt="" class="required_icon">
              <p class="name">{{ $t(item.name) }}</p>
            </div>
            <span class="edit_btn" @click="editBusinessType('businessDetails', 0)">
              <img class="edit_icon" src="@/assets/image/icon-edit.png" alt="">
              <p class="edit_text">{{ $t('message.common.edit') }}</p>
            </span>
          </div>
        </div>
      </div>
      <div class="business_representative_required_fields" v-if="businessRepresentativeRequierList.length > 0">
        <p class="title">{{ $t('message.register.companyRepresentative') }}</p>
        <div class="required_fields">
          <div class="required_field" v-for="item in businessRepresentativeRequierList" :key="item.name">
            <div class="required_field_content">
              <img src="@/assets/image/icon_warning.png" alt="" class="required_icon">
              <p class="name">{{ $t(item.name) }}</p>
            </div>
            <span class="edit_btn" @click="editBusinessType('businessRepresentative', 0)">
              <img class="edit_icon" src="@/assets/image/icon-edit.png" alt="">
              <p class="edit_text">{{ $t('message.common.edit') }}</p>
            </span>
          </div>
        </div>
      </div>
      <div class="business_owners_required_fields" v-if="businessOwnersRequierList.length > 0">
        <p class="title">{{ $t('message.register.companyOwner') }}</p>
        <div class="required_fields">
          <div class="required_field" v-for="item in businessOwnersRequierList" :key="item.name">
            <div class="required_field_content">
              <img src="@/assets/image/icon_warning.png" alt="" class="required_icon">
              <p class="name">{{ $t(item.name) }}</p>
            </div>
            <span class="edit_btn" @click="editBusinessType('businessOwners', 0)">
              <img class="edit_icon" src="@/assets/image/icon-edit.png" alt="">
              <p class="edit_text">{{ $t('message.common.edit') }}</p>
            </span>
          </div>
        </div>
      </div>
      <div class="website_or_app_details_required_fields" v-if="websiteOrAppDetailsRequierList.length > 0">
        <p class="title">{{ $t('message.register.websiteOrApplication') }}</p>
        <div class="required_fields">
          <div class="required_field" v-for="item in websiteOrAppDetailsRequierList" :key="item.name">
            <div class="required_field_content">
              <img src="@/assets/image/icon_warning.png" alt="" class="required_icon">
              <p class="name">{{ $t(item.name) }}</p>
            </div>
            <span class="edit_btn" @click="editBusinessType('websiteOrAppDetails', 0)">
              <img class="edit_icon" src="@/assets/image/icon-edit.png" alt="">
              <p class="edit_text">{{ $t('message.common.edit') }}</p>
            </span>
          </div>
        </div>
      </div>
      <div class="bank_account_required_fields" v-if="bankAccountRequierList.length > 0">
        <p class="title">{{ $t('message.register.bankAccount') }}</p>
        <div class="required_fields">
          <div class="required_field" v-for="item in bankAccountRequierList" :key="item.name">
            <div class="required_field_content">
              <img src="@/assets/image/icon_warning.png" alt="" class="required_icon">
              <p class="name">{{ $t(item.name) }}</p>
            </div>
            <span class="edit_btn" @click="editBusinessType('bankAccount', 1)">
              <img class="edit_icon" src="@/assets/image/icon-edit.png" alt="">
              <p class="edit_text">{{ $t('message.common.edit') }}</p>
            </span>
          </div>
        </div>
      </div>
      <div class="submit_agreement">
        <p class="agreement_text" v-html="$t('message.register.submitAgreementTips')"></p>
        <p class="submit_btn" :class="{ 'disabled': isDisabledBtn }" @click="submitAgreement">{{
          $t('message.register.submitAgreement') }}</p>
      </div>
    </div>
  </div>
  <div class="step_status_success" v-else>
    <div class="descript">
      <p class="title"> {{ $t('message.register.bankAccount_desc.descript.application_submitted') }}</p>

      <p class="content">{{ $t('message.register.bankAccount_desc.descript.descript_content') }}</p>
      <p class="content">{{ $t('message.register.bankAccount_desc.descript.descript_tips') }}</p>
    </div>

  </div>
</template>

<script>

import { isEmptyValue } from '@/utils/tools/validater';

// 判断表单值是否为空 (包括空字符串、空数组、空对象等)
import mixins from '../../mixins';

export default {
  name: 'StepStatus',
  mixins: [mixins],
  components: {},
  data() {
    return {
      businessTypeRequierList: [],
      businessDetailsRequierList: [],
      businessRepresentativeRequierList: [],
      businessOwnersRequierList: [],
      websiteOrAppDetailsRequierList: [],
      bankAccountRequierList: [],
      // 验证必填项字典
      validateRequiredKeyListMap: {
        businessType: {
          businessLocation: {
            key: 'businessLocation',
            name: 'message.register.businessLocation',
          },
        }, // 公司类型--（公司所在地为必填项）
        businessDetails: {
          legalBusinessName: {
            key: 'legalBusinessName',
            name: 'message.register.businessDetails.legal_business_name',
          },
          companyRegistrationNumber: {
            key: 'companyRegistrationNumber',
            name: 'message.register.businessDetails.company_registration_number',
          },
          companyRegistrationDate: {
            key: 'companyRegistrationDate',
            name: 'message.register.businessDetails.company_registration_date',
          },
          // 公司营业名称
          businessName: {
            key: 'businessName',
            name: 'message.register.businessDetails.business_name',
          },
          // 公司号码
          businessPhoneNumber: {
            key: 'businessPhoneNumber',
            name: 'message.register.businessDetails.business_phone_number',
          },
          registeredBusinessAddress: {
            location: {
              key: 'location',
              name: 'message.register.businessDetails.location',
            },
            areaOrCity: {
              key: 'areaOrCity',
              name: 'message.register.businessDetails.area',
            },
            district: {
              key: 'district',
              name: 'message.register.businessDetails.district',
            },
            addressLine1: {
              key: 'addressLine1',
              name: 'message.register.businessDetails.address_line_1',
            },
            postalCode: {
              key: 'postalCode',
              name: 'message.register.businessDetails.postal_code',
            },

          },
          // 上传公司资料
          uploadCompanyCertificates: {
            certificateOfIncorporation: {
              key: 'certificateOfIncorporation',
              name: 'message.register.businessDetails.certificate_of_incorporation',
            },
            businessRegistrationCertificate: {
              key: 'businessRegistrationCertificate',
              name: 'message.register.businessDetails.business_registration_certificate',
            },
            companyNnc1OrNar1: {
              key: 'companyNnc1OrNar1',
              name: 'message.register.businessDetails.company_nnc1_or_nar1',
            },
            explanationOfShareholdingStructure: {
              key: 'explanationOfShareholdingStructure',
              name: 'message.register.businessDetails.explanation_of_shareholding_structure',
            },
            articlesOfAssociation: {
              key: 'articlesOfAssociation',
              name: 'message.register.businessDetails.articles_of_association',
            },
          },
        },
        businessRepresentative: {
          legalName: {
            firstName: {
              key: 'firstName',
              name: 'message.register.companyRepresentative_desc.legalName_firstName',
            },
            lastName: {
              key: 'lastName',
              name: 'message.register.companyRepresentative_desc.legalName_lastName',
            },
          },
          emailAddress: {
            key: 'emailAddress',
            name: 'message.register.companyRepresentative_desc.email_address',
          },
          jobTitle: {
            key: 'jobTitle',
            name: 'message.register.companyRepresentative_desc.job_title',
          },
          dateOfBirth: {
            key: 'dateOfBirth',
            name: 'message.register.companyRepresentative_desc.birthDate',
          },
          homeAddress: {
            location: {
              key: 'location',
              name: 'message.register.businessDetails.location',
            },
            areaOrCity: {
              key: 'areaOrCity',
              name: 'message.register.businessDetails.area',
            },
            district: {
              key: 'district',
              name: 'message.register.businessDetails.district',
            },
            addressLine1: {
              key: 'addressLine1',
              name: 'message.register.businessDetails.address_line_1',
            },
            postalCode: {
              key: 'postalCode',
              name: 'message.register.businessDetails.postal_code',
            },
          },
          phoneNumber: {
            key: 'phoneNumber',
            name: 'message.register.companyRepresentative_desc.phone_number',
          },
          personalIdNumber: {
            key: 'personalIdNumber',
            name: 'message.register.companyRepresentative_desc.personal_id_numbe',
          },
          uploadPersonalIdImages: {
            passport: {
              key: 'passport',
              name: 'message.register.companyRepresentative_desc.passport',
            },
            id: {
              key: 'id',
              name: 'ID',
            },
          },
        },
        businessOwners: {},
        websiteOrAppDetails: {
          businessWebsite: {
            key: 'businessWebsite',
            name: 'message.register.websiteOrApplication_desc.business_website',
          },
          durationOfOperation: {
            key: 'durationOfOperation',
            name: 'message.register.websiteOrApplication_desc.duration_of_operation',
          },
          // websiteDefaultDomain: {
          //   key: 'websiteDefaultDomain',
          //   name: 'message.register.websiteOrApplication_desc.website_default_domain',
          // },
          businessWebsiteType: {
            key: 'businessWebsiteType',
            name: 'message.register.websiteOrApplication_desc.business_website_type',
          },
          industryOrBusinessCategory: {
            key: 'industryOrBusinessCategory',
            name: 'message.register.websiteOrApplication_desc.industry/Business_category',
          },
          monthlyTradingVolumeUsd: {
            key: 'monthlyTradingVolumeUsd',
            name: 'message.register.websiteOrApplication_desc.monthly_trading_volume (USD)',
          },
          monthlyDisputeRate: {
            key: 'monthlyDisputeRate',
            name: 'message.register.websiteOrApplication_desc.monthly_dispute_rate',
          },
          monthlyRefundRate: {
            key: 'monthlyRefundRate',
            name: 'message.register.websiteOrApplication_desc.monthly_refund_rate',
          },
          market: {
            key: 'market',
            name: 'message.register.websiteOrApplication_desc.market',
          },
          uploadBusinessProofs: {
            transactionStatementsLastThreeMonths: {
              key: 'transactionStatementsLastThreeMonths',
              name: 'message.register.websiteOrApplication_desc.Transaction statements (last 3 months)',
            },
            // screenshotsOfBusinessPlatforms: {
            //   key: 'screenshotsOfBusinessPlatforms',
            //   name: 'message.register.websiteOrApplication_desc.Screenshots of business platforms',
            // },
          },
        },
        bankAccount: {
          accountHolderName: {
            key: 'accountHolderName',
            name: 'message.register.bankAccount_desc.bank_name',
          },
          depositBank: {
            key: 'depositBank',
            name: 'message.register.bankAccount_desc.bank_address',
          },
          bankAddress: {
            key: 'bankAddress',
            name: 'message.register.bankAccount_desc.bank_account_location',
          },
          currency: {
            key: 'currency',
            name: 'message.register.bankAccount_desc.Currency',
          },
          accountNumber: {
            key: 'accountNumber',
            name: 'message.register.bankAccount_desc.bank_account_number_HK',
          },
          confirmAccountNumber: {
            key: 'confirmAccountNumber',
            name: 'message.register.bankAccount_desc.Confirm account number',
          },
          proofOfBankAccount: {
            key: 'proofOfBankAccount',
            name: 'message.register.bankAccount_desc.Account Opening Proof',
          },
        },
      },
    };
  },

  methods: {
    editBusinessType(type, index) {
      this.$emit('editBusinessType', type, index);
    },
    submitAgreement() {
      !this.isDisabledBtn && this.$emit('updateFormData', { currentStep: 'status', nextStep: 'status' });
    },
  },

  watch: {
    applicationInfo: {
      handler(newVal) {
        const {
          businessType, businessDetails, businessRepresentative, businessOwners, websiteOrAppDetails, bankAccount,
          businessType: {
            businessLocation,
          },
          websiteOrAppDetails: {
            businessWebsiteType,
          },
        } = newVal;
        if (businessType) {
          Object.keys(this.validateRequiredKeyListMap.businessType).forEach(key => {
            if (isEmptyValue(businessType[key])) {
              this.businessTypeRequierList.push({
                key: this.validateRequiredKeyListMap.businessType[key].key,
                name: this.validateRequiredKeyListMap.businessType[key].name,
              });
            }
          });
        }
        if (businessDetails) {
          if (businessLocation === 'United Kingdom') {
            this.validateRequiredKeyListMap.businessDetails.uploadCompanyCertificates = {
              certificateOfIncorporation: {
                key: 'certificateOfIncorporation',
                name: 'message.register.businessDetails.certificate_of_incorporation',
              },
              explanationOfShareholdingStructure: {
                key: 'explanationOfShareholdingStructure',
                name: 'message.register.businessDetails.explanation_of_shareholding_structure',
              },
              articlesOfAssociation: {
                key: 'articlesOfAssociation',
                name: 'message.register.businessDetails.articles_of_association',
              },
            };
          } else if (businessLocation === 'Hong Kong SAR China') {
            this.validateRequiredKeyListMap.businessDetails.uploadCompanyCertificates = {
              certificateOfIncorporation: {
                key: 'certificateOfIncorporation',
                name: 'message.register.businessDetails.certificate_of_incorporation',
              },
              businessRegistrationCertificate: {
                key: 'businessRegistrationCertificate',
                name: 'message.register.businessDetails.business_registration_certificate',
              },
              companyNnc1OrNar1: {
                key: 'companyNnc1OrNar1',
                name: 'message.register.businessDetails.company_NNC1/NAR1',
              },
            };
          }
          Object.keys(this.validateRequiredKeyListMap.businessDetails).forEach(key => {
            if (key === 'registeredBusinessAddress') {
              Object.keys(this.validateRequiredKeyListMap.businessDetails.registeredBusinessAddress).forEach(_key => {
                if (isEmptyValue(businessDetails[key][_key])) {
                  this.businessDetailsRequierList.push({
                    key: this.validateRequiredKeyListMap.businessDetails.registeredBusinessAddress[_key].key,
                    name: this.validateRequiredKeyListMap.businessDetails.registeredBusinessAddress[_key].name,
                  });
                }
              });
            }
            if (key === 'uploadCompanyCertificates') {
              Object.keys(this.validateRequiredKeyListMap.businessDetails.uploadCompanyCertificates).forEach(_key => {
                if (isEmptyValue(businessLocation)) {
                  return;
                }
                if (isEmptyValue(businessDetails[key][_key])) {
                  if (businessLocation === 'Hong Kong SAR China' && ['certificateOfIncorporation', 'businessRegistrationCertificate', 'companyNnc1OrNar1'].includes(_key)) {
                    this.businessDetailsRequierList.push({
                      key: this.validateRequiredKeyListMap.businessDetails.uploadCompanyCertificates[_key].key,
                      name: this.validateRequiredKeyListMap.businessDetails.uploadCompanyCertificates[_key].name,
                    });
                  } else if (businessLocation === 'United Kingdom' && ['certificateOfIncorporation', 'explanationOfShareholdingStructure', 'articlesOfAssociation'].includes(_key)) {
                    this.businessDetailsRequierList.push({
                      key: this.validateRequiredKeyListMap.businessDetails.uploadCompanyCertificates[_key].key,
                      name: this.validateRequiredKeyListMap.businessDetails.uploadCompanyCertificates[_key].name,
                    });
                  }
                }
              });
            }
            if (isEmptyValue(businessDetails[key])) {
              this.businessDetailsRequierList.push({
                key: this.validateRequiredKeyListMap.businessDetails[key].key,
                name: this.validateRequiredKeyListMap.businessDetails[key].name,
              });
            }
          });
        }
        if (businessRepresentative) {
          Object.keys(this.validateRequiredKeyListMap.businessRepresentative).forEach(key => {
            if (['homeAddress', 'legalName', 'uploadPersonalIdImages'].includes(key)) {
              Object.keys(this.validateRequiredKeyListMap.businessRepresentative[key]).forEach(_key => {
                if (isEmptyValue(businessRepresentative[key][_key])) {
                  this.businessRepresentativeRequierList.push({
                    key: this.validateRequiredKeyListMap.businessRepresentative[key][_key].key,
                    name: this.validateRequiredKeyListMap.businessRepresentative[key][_key].name,
                  });
                }
              });
            } else if (isEmptyValue(businessRepresentative[key])) {
              this.businessRepresentativeRequierList.push({
                key: this.validateRequiredKeyListMap.businessRepresentative[key].key,
                name: this.validateRequiredKeyListMap.businessRepresentative[key].name,
              });
            }
            // 公司代表中 ID和护照存在一个就行
            if (key === 'uploadPersonalIdImages') {
              if (!isEmptyValue(businessRepresentative[key].id)) {
                this.businessRepresentativeRequierList = this.businessRepresentativeRequierList.filter(item => item.key !== 'passport');
              }
              if (!isEmptyValue(businessRepresentative[key].passport)) {
                this.businessRepresentativeRequierList = this.businessRepresentativeRequierList.filter(item => item.key !== 'id');
              }
            }
          });
        }
        if (businessOwners) {
          if (isEmptyValue(businessOwners)) {
            this.businessOwnersRequierList.push({
              key: 'message.register.companyOwner',
              name: 'message.register.companyOwner',
            });
          } else {
            this.businessOwnersRequierList = [];
            const flag = businessOwners.some(item => {
              return isEmptyValue(item.legalName.firstName) || isEmptyValue(item.legalName.lastName);
            });
            flag && this.businessOwnersRequierList.push({
              key: 'message.register.companyOwner',
              name: 'message.register.companyOwner',
            });
          }
        }
        if (websiteOrAppDetails) {
          // 如果是WEB02，则domain为必填
          if (businessWebsiteType && businessWebsiteType === 'WEB02') {
            //  this.validateRequiredKeyListMap.websiteOrAppDetails 加上websiteDefaultDomain
            this.$set(this.validateRequiredKeyListMap.websiteOrAppDetails, 'websiteDefaultDomain', {
              key: 'websiteDefaultDomain',
              name: 'message.register.websiteOrApplication_desc.website_default_domain',
            });
          } else {
            // this.validateRequiredKeyListMap.websiteOrAppDetails 去掉websiteDefaultDomain
            const { websiteDefaultDomain, ...rest } = this.validateRequiredKeyListMap.websiteOrAppDetails;
            this.validateRequiredKeyListMap.websiteOrAppDetails = rest;
          }
          Object.keys(this.validateRequiredKeyListMap.websiteOrAppDetails).forEach(key => {
            if (key === 'uploadBusinessProofs') {
              Object.keys(this.validateRequiredKeyListMap.websiteOrAppDetails.uploadBusinessProofs).forEach(_key => {
                if (isEmptyValue(websiteOrAppDetails[key][_key])) {
                  this.websiteOrAppDetailsRequierList.push({
                    key: this.validateRequiredKeyListMap.websiteOrAppDetails.uploadBusinessProofs[_key].key,
                    name: this.validateRequiredKeyListMap.websiteOrAppDetails.uploadBusinessProofs[_key].name,
                  });
                }
              });
            } else if (isEmptyValue(websiteOrAppDetails[key])) {
              this.websiteOrAppDetailsRequierList.push({
                key: this.validateRequiredKeyListMap.websiteOrAppDetails[key].key,
                name: this.validateRequiredKeyListMap.websiteOrAppDetails[key].name,
              });
            }
          });
        }
        if (bankAccount) {
          Object.keys(this.validateRequiredKeyListMap.bankAccount).forEach(key => {
            if (isEmptyValue(bankAccount[key])) {
              this.bankAccountRequierList.push({
                key: this.validateRequiredKeyListMap.bankAccount[key].key,
                name: this.validateRequiredKeyListMap.bankAccount[key].name,
              });
            }
          });
        }
      },
      deep: true,
    },
  },
  computed: {
    isDisabledBtn() {
      return this.applicationInfo.currentStep === 'status' || this.businessTypeRequierList.length > 0 || this.businessDetailsRequierList.length > 0 || this.businessRepresentativeRequierList.length > 0 || this.businessOwnersRequierList.length > 0 || this.websiteOrAppDetailsRequierList.length > 0 || this.bankAccountRequierList.length > 0;
    },
  },
};
</script>

<style scoped lang="scss">
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  list-style: none;
}

.step_status {
  .descript {
    .title {
      font-family: "PingFangSC, PingFang SC";
      font-weight: 600;
      font-size: 32px;
      color: #264373;
      line-height: 32px;
      text-align: left;
      font-style: normal;
      margin-bottom: 12px;
    }

    .content {
      font-weight: 400;
      font-size: 14px;
      color: #B7C4CE;
      line-height: 18px;
      text-align: left;
      font-style: normal;
      margin: 12px 0 24px;
    }
  }

  .show_required_fields {

    .title {
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      font-size: 14px;
      color: #264373;
      line-height: 18px;
      text-align: left;
      font-style: normal;
    }

    .required_fields {

      margin-top: 8px;
      margin-bottom: 20px;

      .required_icon {
        width: 14px;
        height: 12px;
        margin-right: 8px;
      }

      .required_field {
        background: rgba(231, 60, 61, 0.05);
        border-radius: 4px;
        border: 1px solid #E73C3D;
        height: 54px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin: 8px 0;
        padding: 0 16px;

        .required_field_content {
          display: flex;
          align-items: center;

          .name {
            font-family: "PingFangSC, PingFang SC";
            font-weight: 400;
            font-size: 14px;
            color: #264373;
            line-height: 18px;
            text-align: left;
            font-style: normal;
          }
        }

        .edit_btn {
          display: flex;
          align-items: center;
          width: 72px;
          height: 30px;
          background: #fff;
          border-radius: 4px;
          padding: 5px 11px;
          cursor: pointer;

          .edit_icon {
            width: 16px;
            height: 16px;
            margin-right: 4px;
          }

          .edit_text {
            font-family: PingFangSC, PingFang SC;
            font-weight: 600;
            font-size: 14px;
            color: #264373;
            line-height: 20px;
            text-align: left;
            font-style: normal;
          }
        }
      }
    }

  }

  .submit_agreement {
    .agreement_text {
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 14px;
      color: #B7C4CE;
      line-height: 18px;
      text-align: left;
      font-style: normal;
      margin-top: 44px;
      margin-bottom: 24px;
    }

    .submit_btn {
      height: 44px;
      background: #00A2DD;
      border-radius: 2px;
      color: #fff;
      cursor: pointer;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 16px;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;

      &.disabled {
        background: #D1D1D1;

      }
    }
  }
}

.service-agreement {
  color: #264373;
  text-decoration: underline;
}

.step_status_success {
  .descript {
    height: 100%;
    overflow: hidden;

    .title {
      font-family: "PingFangSC, PingFang SC";
      font-weight: 600;
      font-size: 32px;
      color: #264373;
      line-height: 32px;
      text-align: left;
      font-style: normal;
      margin-bottom: 12px;
    }

    .content {
      font-weight: 400;
      font-size: 14px;
      color: #B7C4CE;
      line-height: 18px;
      text-align: left;
      font-style: normal;
      margin: 12px 0 24px;
    }
  }
}
</style>
